// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"_4dfb5b14","withDimBackground":"_a0fd09f6"};